import qs from 'qs';

export const getQueryParam = (name) => {
  let query;

  if (window.location.search) {
    query = window.location.search.substring(1);
  } else if (window.location.hash) {
    // eslint-disable-next-line
    query = window.location.hash.split('?')[1];
  }

  if (query) {
    const parsedQuery = qs.parse(query);
    return name ? parsedQuery[name] : parsedQuery;
  }

  return name ? '' : {};
};
